import { Divider, Grid, makeStyles, Typography } from "@material-ui/core";
import moment from "moment";
import styled from "styled-components";
import { useWindowDimensions } from "utils/dimensionHook";
import { useFormState } from "react-final-form";

interface ISchoolLocationInDragable {
  schoolData: ISchool;
  waveType: string;
  keyRoute?: number;
  routePlanData?: any;
}

const useStyles = makeStyles({
  dragContentTitleText: {
    fontSize: "13pt",
    fontWeight: 500,
    color: "#000000",
    marginTop: 10,
  },
  dragContentTitleTextSmallScreen: {
    fontSize: "11pt",
    fontWeight: 500,
    color: "#000000",
    marginTop: 10,
  },
});

const SchoolLocationInDragable = ({
  schoolData,
  waveType,
  keyRoute,
  routePlanData,
}: ISchoolLocationInDragable) => {
  const classes = useStyles();
  const { width } = useWindowDimensions();
  const { values } = useFormState();

  const getItemStyle = () => ({
    border: "1px solid #EAEAEA",
    padding: "5px 8px",
    background: "#FFFFFF",
  });

  const Item = styled.div`
    &:hover {
      box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.08);
    },
  `;

  const getListStyle = () => ({
    background: "#FBFBFB",
    width: "100%",
  });

  return (
    <div style={getListStyle()}>
      <Item style={getItemStyle()}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography
              className={
                width <= 1024
                  ? classes.dragContentTitleTextSmallScreen
                  : classes.dragContentTitleText
              }
            >
              {schoolData.name}
            </Typography>
          </Grid>

          <Grid item xs={12}>
            <Divider />
          </Grid>

          {keyRoute ? (
            <Grid item xs={12}>
              <Typography variant="body2">{`${schoolData.address} (${moment(
                waveType === "from_school"
                  ? routePlanData.routes[keyRoute].startTime
                  : routePlanData.routes[keyRoute].endTime,
                "HH:mm"
              ).format("HH:mm")})`}</Typography>
            </Grid>
          ) : (
            <Grid item xs={12}>
              <Typography variant="body2">{`${schoolData.address} (${moment(
                waveType === "from_school"
                  ? values.route?.startTime
                  : values.route?.endTime,
                "HH:mm"
              ).format("HH:mm")})`}</Typography>
            </Grid>
          )}
        </Grid>
      </Item>
    </div>
  );
};

export default SchoolLocationInDragable;
